import { Dispatch, SetStateAction, useCallback } from 'react';
import { useUpdateUserSettingsMutation } from 'shared/hooks/queries/use-update-user-settings-mutation';
import { useUserQuery } from 'shared/hooks/queries/use-user-query';

export const useSmartListsSectionOpen = (): [
  boolean,
  Dispatch<SetStateAction<boolean>>,
] => {
  const { data: user } = useUserQuery();
  const { mutate: updateSettings } = useUpdateUserSettingsMutation();

  const isOpen = user?.settings?.smartListsSectionOpen ?? false;

  const setOpen: Dispatch<SetStateAction<boolean>> = useCallback(
    (action) => {
      const value = typeof action === 'function' ? action(isOpen) : action;
      updateSettings({ smartListsSectionOpen: value });
    },
    [isOpen, updateSettings],
  );

  return [isOpen, setOpen];
};
